export default {
  LOADING_GET_EARN_PRODUCTS: 'LOADING_GET_EARN_PRODUCTS',
  SUCCESS_GET_EARN_PRODUCTS: 'SUCCESS_GET_EARN_PRODUCTS',
  ERROR_GET_EARN_PRODUCTS: 'ERROR_GET_EARN_PRODUCTS',

  LOADING_GET_EARN_SUBSCRIPTIONS: 'LOADING_GET_EARN_SUBSCRIPTIONS',
  SUCCESS_GET_EARN_SUBSCRIPTIONS: 'SUCCESS_GET_EARN_SUBSCRIPTIONS',
  ERROR_GET_EARN_SUBSCRIPTIONS: 'ERROR_GET_EARN_SUBSCRIPTIONS',

  LOADING_GET_EARN_HISTORY: 'LOADING_GET_EARN_HISTORY',
  SUCCESS_GET_EARN_HISTORY: 'SUCCESS_GET_EARN_HISTORY',
  ERROR_GET_EARN_HISTORY: 'ERROR_GET_EARN_HISTORY',

  LOADING_GET_EARN_SUBSCRIPTION_TRANSACTIONS: 'LOADING_GET_EARN_SUBSCRIPTION_TRANSACTIONS',
  SUCCESS_GET_EARN_SUBSCRIPTION_TRANSACTIONS: 'SUCCESS_GET_EARN_SUBSCRIPTION_TRANSACTIONS',
  ERROR_GET_EARN_SUBSCRIPTION_TRANSACTIONS: 'ERROR_GET_EARN_SUBSCRIPTION_TRANSACTIONS',

  SET_EARN_SUBSCRIPTION_FILTERS: 'SET_EARN_SUBSCRIPTION_FILTERS',

  SIGNALR_CREATE_EARN: 'SIGNALR_INCOME/ReceiveMessage/EarnTopUpEvent',
  SIGNALR_REDEMPTION_EARN: 'SIGNALR_INCOME/ReceiveMessage/EarnRedemptionEvent',
} as const;
